<div class="place-content-center">
  <div>
    <div class="flex items-center justify-between gap-x-2">
      <div>Upload to Portal</div>
      <div class="relative flex items-center">
      </div>
    </div>
  </div>
</div>
